// Gestion de la session côté navigateur.
// Toute réponse 401 de l'API (jeton expiré, invalide, compte désactivé)
// ramène l'utilisateur à l'écran de connexion.

export const clearSession = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

const isApiCall = (url) => typeof url === 'string' && url.includes('/api/') && !url.includes('/api/auth/login');

export const handleUnauthorized = () => {
  clearSession();
  if (window.location.pathname !== '/login') {
    window.location.assign('/login?expired=1');
  }
};

/** Vérifie qu'un jeton stocké est un JWT non expiré (sans le valider : c'est le rôle du serveur). */
export const isTokenUsable = (token) => {
  if (!token || token.split('.').length !== 3) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return !payload.exp || payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
};

/** Intercepte window.fetch pour traiter les 401 de l'API au même endroit. */
export const installFetchInterceptor = () => {
  if (window.__doccFetchPatched) return;
  window.__doccFetchPatched = true;
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    const response = await originalFetch(input, init);
    const url = typeof input === 'string' ? input : input?.url;
    if (response.status === 401 && isApiCall(url)) handleUnauthorized();
    return response;
  };
};
